import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../util/types';
import { Slider, ListingCard } from '../../components';
import classNames from 'classnames';

import css from './SectionWatchlistListings.module.css';

// slidesToShow
const SLIDES_TO_SHOW_TABLET = 3;
const SLIDES_TO_SHOW_DESKTOP = 5;
// slidesToScroll
const SLIDES_TO_SCROLL_TABLET = 3;
const SLIDES_TO_SCROLL_DESKTOP = 3;

const SectionWatchlistListings = props => {
  const {
    rootClassName,
    className,
    titleClassName,
    arrowsClassName,
    intl,
    listings,
    queryWatchlistListingsInProgress,
    queryWatchlistListingsError,
    slidesToShow,
    slidesToScroll,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const titleClasses = classNames(css.title, titleClassName);

  // The length check already hides the empty state; dropping the
  // inProgress term keeps the rendered slider visible during
  // post-hydration refetches (see SectionListings).
  if (queryWatchlistListingsError || listings.length === 0) {
    return null;
  }

  const sliderTitle = intl.formatMessage({ id: 'SectionWatchlistListings.title' });
  return (
    <div className={classes}>
      <Slider
        id="LandingPage.watchlistSlider"
        headerClassName={css.header}
        titleClassName={titleClasses}
        title={sliderTitle}
        itemClassName={css.sliderItem}
        arrowsClassName={arrowsClassName}
        slidesToShow={{
          tablet: slidesToShow?.tablet || SLIDES_TO_SHOW_TABLET,
          desktop: slidesToShow?.desktop || SLIDES_TO_SHOW_DESKTOP,
        }}
        slidesToScroll={{
          tablet: slidesToScroll?.tablet || SLIDES_TO_SCROLL_TABLET,
          desktop: slidesToScroll?.desktop || SLIDES_TO_SCROLL_DESKTOP,
        }}
      >
        {listings.map(l => {
          return <ListingCard key={l.id.uuid} listing={l} />;
        })}
      </Slider>
    </div>
  );
};

SectionWatchlistListings.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  arrowsClassName: null,
  queryWatchlistListingsInProgress: false,
  queryWatchlistListingsError: null,
};

const { arrayOf, bool, string } = PropTypes;

SectionWatchlistListings.propTypes = {
  rootClassName: string,
  className: string,
  titleClassName: string,
  arrowsClassName: string,

  listings: arrayOf(propTypes.listing),
  queryWatchlistListingsInProgress: bool.isRequired,
  queryWatchlistListingsError: propTypes.error,
};

export default SectionWatchlistListings;
